var exports = {
  "AS": "x234b8571--c72f81--item",
  "wm": "x234b8571--c72f81--logo",
  "ot": "x234b8571--c72f81--logo-icon",
  "Qs": "x234b8571--c72f81--content",
};

module.exports = exports;
